import { useKeyPress } from 'hooks/useKeyPress';
import styled from '@emotion/styled';
import { Text } from 'components';
import { Trans, t } from '@lingui/macro';
import { CenterContainer } from './CenterContainer';
import { AuthButton } from './AuthButton';
import { useLogin } from '../hooks/federatedAuthHooks';

export const LoginFederated = () => {
  const login = useLogin();
  useKeyPress('Enter', () => {
    login();
  });

  return (
    <CenterContainer welcomeText={<Trans>... Welcome back</Trans>}>
      <Center>
        <Header>
          <Text variant="headlineXs" weight="semiBold">
            <Trans>Log in to your account</Trans>
          </Text>
        </Header>
        <AuthButton buttonText={t`Log in`} onSubmit={() => login()} />
      </Center>
    </CenterContainer>
  );
};

const Header = styled.h1`
  margin-bottom: 16px;
  color: ${p => p.theme.palette.text.primary};
  font-weight: 600;
  font-size: 1.125rem;
`;

const Center = styled.div`
  margin: 16px 24px;
  gap: 16px;
  display: flex;
  flex-direction: column;
  svg {
    fill: ${p => p.theme.palette.fg.quinary};
  }
`;
